<template>

  <div class="summary" v-if="(this.$store.getters.getPermissions?.viewComments === true) || (this.$store.getters.getPermissions?.permissionGod === true)">
    <div class="tab">
      <span
          v-if="this.$store.getters.getPermissions?.viewComments === true"
          class="tab_title"
          :class="{ active : block==='Comments'}"
          @click="selected_block('Comments')">
        {{this.translate('summary.comments.title')}}
      </span>
      <span
          v-if="this.$store.getters.getPermissions?.permissionGod === true"
          class="tab_title"
          :class="{ active : block==='HistoryAction'}"
          @click="selected_block('HistoryAction')"
      >
        {{this.translate('summary.actions.title')}}
      </span>
    </div>
    <div class="block">
      <Comments
        v-if="block==='Comments'"
        :params="comments_params"
      />
      <HistoryAction
        v-if="block==='HistoryAction'"
        :type="this.type"
        :params="actions_params"
      />
    </div>
  </div>

</template>
<script>

import Comments from "@/views/Dashboard/common/General/Summary/Comments.vue";
import HistoryAction from "./Summary/HistoryAction.vue";

export default {
  name: 'Summary',
  props: ['type', 'info'],
  components: {
    Comments,
    HistoryAction
  },
  data () {
    return {
      block: 'Comments',
    }
  },
  computed:{
    comments_params(){
      switch (this.type) {
        case 'device': return { device_id: this.info.id };
        case 'simcard_devices': return { device_simcard_id: this.info.id };
        case 'simcard_profile': return { simcard_profile_id: this.info.id };
        case 'esim_profile': return { esim_profile_id: this.info.id };
      }
    },
    actions_params(){
      switch (this.type) {
        case 'device': return { fid: this.info.fid };
        case 'simcard_devices': return { simcard_id: this.info.id };
        case 'simcard_profile': return {imsi: this.info.imsi, iccid: this.info.iccid};
        case 'esim_profile': return {imsi: this.info.imsi, iccid: this.info.iccid};
      }
    }
  },
  methods: {
    selected_block(block){
      this.block = block
    }
  }
}
</script>

<style lang='scss' scoped>
.summary{
  height: 100%;
  .tab{
    width: 100%;
    height: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: #f8f8f8;
        border-bottom: 1px solid #f8f8f8;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

</style>
